import type { Key } from "react";
import type { IResponsiveTabsProps } from ".";

export const ResponsiveTabsFull = <Value extends Key, Tab>({
  tabs,
  value,
  getValue,
  onChange,
  renderTab,
}: Omit<IResponsiveTabsProps<Value, Tab>, "breakpoint" | "getLabel">) => {
  return tabs.map((tab) => {
    const currentTabValue = getValue(tab);
    return renderTab(tab, () => onChange(currentTabValue), currentTabValue === value);
  });
};
